
var $ = jQuery;

$(document).ready(function () {
    checkTabContent();
});

function checkTabContent() {
    let tabPane = document.getElementsByClassName('tab-pane');

    setTimeout(() => {
        for (let x = 0; x < tabPane.length; x++) {
            if (tabPane[x].classList.contains('active')) {
                tabPane[x].style.display = 'block';
            } else {
                tabPane[x].style.display = 'none';
            }
        }
    }, 500);
}